import { render, staticRenderFns } from "./CurrencyTemplate.vue?vue&type=template&id=05c72dec&scoped=true"
import script from "./CurrencyTemplate.vue?vue&type=script&lang=js"
export * from "./CurrencyTemplate.vue?vue&type=script&lang=js"
import style0 from "./CurrencyTemplate.vue?vue&type=style&index=0&id=05c72dec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c72dec",
  null
  
)

export default component.exports